import _regeneratorRuntime from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _classCallCheck from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

export var AsyncSerialScheduler =
/*#__PURE__*/
function () {
  function AsyncSerialScheduler(observer) {
    _classCallCheck(this, AsyncSerialScheduler);

    this._baseObserver = observer;
    this._pendingPromises = new Set();
  }

  _createClass(AsyncSerialScheduler, [{
    key: "complete",
    value: function complete() {
      var _this = this;

      Promise.all(this._pendingPromises).then(function () {
        return _this._baseObserver.complete();
      }).catch(function (error) {
        return _this._baseObserver.error(error);
      });
    }
  }, {
    key: "error",
    value: function error(_error) {
      this._baseObserver.error(_error);
    }
  }, {
    key: "schedule",
    value: function schedule(task) {
      var _this2 = this;

      var prevPromisesCompletion = Promise.all(this._pendingPromises);
      var values = [];

      var next = function next(value) {
        return values.push(value);
      };

      var promise = Promise.resolve().then(function () {
        return __awaiter(_this2, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var _i, value;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return prevPromisesCompletion;

                case 2:
                  _context.next = 4;
                  return task(next);

                case 4:
                  this._pendingPromises.delete(promise);

                  for (_i = 0; _i < values.length; _i++) {
                    value = values[_i];

                    this._baseObserver.next(value);
                  }

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
      }).catch(function (error) {
        _this2._pendingPromises.delete(promise);

        _this2._baseObserver.error(error);
      });

      this._pendingPromises.add(promise);
    }
  }]);

  return AsyncSerialScheduler;
}();